"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CooccurrenceResult = exports.CooccurrenceResultVenn = exports.CooccurrenceResultCluster = void 0;
const axios_1 = __importDefault(require("axios"));
const downloadFile_1 = require("@common/tsutils/downloadFile");
class Mwm {
    constructor(raw) {
        this.genus = raw.genus;
        this.species = raw.species;
        this.num_samples = +raw.num_samples;
        this.typechar = raw.typechar;
    }
}
class CooccurrenceResultCluster {
    constructor(raw, clusters) {
        this.percentage = 0;
        this.mwms = [];
        const filled_clusters = clusters.all().filter(c => c.samples.length);
        this.name = filled_clusters[+raw.cluster].name_or_default;
        this.idx = filled_clusters[+raw.cluster].idx;
        this.num = +raw.num;
        for (let [key, m] of Object.entries(raw.mwms)) {
            this.mwms.push(new Mwm(m));
        }
    }
}
exports.CooccurrenceResultCluster = CooccurrenceResultCluster;
class CooccurrenceResultVenn {
    constructor(raw, clusters) {
        this.clusters = raw.clusters.map((x) => +x);
        this.num = +raw.num;
    }
}
exports.CooccurrenceResultVenn = CooccurrenceResultVenn;
class CooccurrenceResult {
    constructor(raw, clusters) {
        this.affinity = [];
        this.diversity = [];
        this.strength = [];
        this.uniqueness = [];
        this.cluster_idxs = [];
        this.clusters = clusters;
        this.init(this.affinity, raw.affinity, clusters);
        this.init(this.diversity, raw.diversity, clusters);
        this.init(this.strength, raw.strength, clusters);
        this.init(this.uniqueness, raw.uniqueness, clusters);
        this.venn = raw.venn.map((v) => new CooccurrenceResultVenn(v, clusters));
        this.cluster_idxs = clusters.all().filter(c => c.samples.length).map(c => c.idx);
    }
    init(item, raw, clusters) {
        raw.forEach((c) => {
            item.push(new CooccurrenceResultCluster(c, clusters));
        });
        const max = item.reduce((acumm, cluster) => Math.max(acumm, cluster.num), 0);
        item.forEach(cluster => cluster.percentage = max ? cluster.num / max : 0);
    }
    downloadRaw() {
        const self = this;
        let str = '';
        function print_line(line = '') {
            str += line + '\n';
        }
        function print_title(t, level = 0) {
            for (let i = -1; i < level; i++)
                print_line();
            const line = (level === 0 ? '-' : '=').repeat(80);
            print_line(line);
            print_line(' ' + t);
            print_line(line);
        }
        function add_text_clusters() {
            print_title('Clusters', 1);
            self.clusters.clusters.forEach(c => {
                print_line(`* #${c.idx}: ${c.name_or_default}`);
            });
        }
        function add_text_venn() {
            print_title('Venn', 1);
            self.venn.map(group => {
                let line = '* Clusters: ';
                line += group.clusters.join(', ');
                line = line.padEnd(40);
                line += `#mwms: ${group.num}`;
                print_line(line);
            });
        }
        function add_text_group(title, clusters) {
            print_title(title, 1);
            clusters.map(cluster => {
                let subtitle = `Cluster #${cluster.idx} '`;
                subtitle += self.clusters.clusters[cluster.idx].name_or_default + "'";
                print_title(title + ' - ' + subtitle);
                print_line('Number of mwms: ' + cluster.num);
                let mwms = cluster.mwms.map(x => x);
                mwms.sort((a, b) => b.num_samples - a.num_samples);
                mwms.map(mwm => {
                    let line = `* ${mwm.genus} ${mwm.species}`;
                    line = line.padEnd(40);
                    line += ` #samples: ${mwm.num_samples}`;
                    print_line(line);
                });
            });
        }
        function add_text_group_summary(title, clusters) {
            print_title(title);
            clusters.map(cluster => {
                let line = `* Cluster #${cluster.idx} '`;
                line += self.clusters.clusters[cluster.idx].name_or_default + "'";
                line = line.padEnd(40);
                line += ` #mwms: ${cluster.num}`;
                print_line(line);
            });
        }
        add_text_clusters();
        add_text_venn();
        print_title('Summary', 1);
        add_text_group_summary('Uniqueness', self.uniqueness);
        add_text_group_summary('Uniqueness Strength', self.strength);
        add_text_group_summary('Diversity', self.diversity);
        add_text_group_summary('Affinity', self.affinity);
        add_text_group('Uniqueness', self.uniqueness);
        add_text_group('Uniqueness Strength', self.strength);
        add_text_group('Diversity', self.diversity);
        add_text_group('Affinity', self.affinity);
        (0, downloadFile_1.downloadTXT)(str, "cooccurrence.txt");
    }
}
exports.CooccurrenceResult = CooccurrenceResult;
class Cooccurrence {
    constructor(clusters) {
        this.clusters = clusters;
    }
    async compare() {
        const cluster_payload = this.clusters.toPayload();
        const data = {
            clusters: cluster_payload,
        };
        const response = (await axios_1.default.post('/toolkit/cooccurrence/compare', data)).data;
        const result = new CooccurrenceResult(response, this.clusters);
        return result;
    }
}
exports.default = Cooccurrence;
